import DeductionForm from './deduction-form'
import DeductionList from './deduction-list'

export default {
  strict: false,
  namespaced: true,
  state: Object.assign(
    DeductionForm.state,
    DeductionList.state
  ),
  mutations: Object.assign(
    DeductionForm.mutations,
    DeductionList.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/provider-deductions/index.js